export default __webpack_public_path__ + "static/media/dummy-google-smtp.e3a4211c.png";